module.exports = __webpack_public_path__ + "static/media/doken.5b196439.png";